import React from 'react';
import { TableField } from './TableField';

export function DomainGroupField({ field, value, onChange }) {
  const domains = value && value.length ? value : [];

  const updateDomain = (idx, patch) => {
    const next = domains.map((d, i) => (i === idx ? { ...d, ...patch } : d));
    onChange(next);
  };
  const addDomain = () => onChange([...domains, { domainName: '', indicators: [], strengths: '', gaps: '' }]);
  const removeDomain = (idx) => onChange(domains.filter((_, i) => i !== idx));

  return (
    <div className="rb-domain-group">
      {field.howTo && <p className="rb-howto">{field.howTo}</p>}
      {domains.length === 0 && <p className="rb-empty-note">No domains added yet for this pillar.</p>}

      {domains.map((domain, idx) => (
        <div className="rb-domain-card" key={idx}>
          <div className="rb-domain-card-head">
            <span className="rb-domain-index">Domain {idx + 1}</span>
            <input
              className="rb-domain-name-input"
              type="text"
              placeholder="Domain name"
              value={domain.domainName || ''}
              onChange={(e) => updateDomain(idx, { domainName: e.target.value })}
            />
            <button type="button" className="rb-icon-btn rb-icon-btn-danger" onClick={() => removeDomain(idx)} title="Remove domain">
              ✕ Remove
            </button>
          </div>

          <label className="rb-field-label">{field.subFields.indicators.label}</label>
          <TableField
            field={field.subFields.indicators}
            value={domain.indicators}
            onChange={(v) => updateDomain(idx, { indicators: v })}
          />

          <label className="rb-field-label">{field.subFields.strengths.label}</label>
          <textarea
            className="rb-textarea"
            rows={3}
            value={domain.strengths || ''}
            onChange={(e) => updateDomain(idx, { strengths: e.target.value })}
          />

          <label className="rb-field-label">{field.subFields.gaps.label}</label>
          <textarea
            className="rb-textarea"
            rows={3}
            value={domain.gaps || ''}
            onChange={(e) => updateDomain(idx, { gaps: e.target.value })}
          />
        </div>
      ))}

      <button type="button" className="rb-add-domain-btn" onClick={addDomain}>
        + Add domain
      </button>
    </div>
  );
}
